import React, { FC } from 'react';
import { NavPrivate } from './NavPrivate';
import { NavPublic } from './NavPublic';
import { useUser } from '../user/useUser';
import { NavHeader } from './components/header/NavHeader';
import { NavGroup } from './components/group/NavGroup';

type Props = {
  hideDemo?: boolean;
};

export const Navigation: FC<Props> = ({ hideDemo }) => {
  const { loggedIn, currentUser, accessPremium } = useUser();
  return (
    <NavHeader>
      <NavGroup>
        {loggedIn && (
          <NavPrivate currentUser={currentUser} accessPremium={accessPremium} />
        )}
        {!loggedIn && <NavPublic hideDemo={hideDemo} />}
      </NavGroup>
    </NavHeader>
  );
};
